import { LinkButton } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";

interface ClientsEmptyStateProps {
  hasFilters?: boolean;
}

export const ClientsEmptyState = ({ hasFilters }: ClientsEmptyStateProps) => {
  const getDescription = () => {
    if (hasFilters) {
      return "There are no clients matching your filter criteria at the moment.";
    }
    return "You haven't added anything to this section. Get started by clicking the button below.";
  };

  return (
    <EmptyState title="Manage Clients" description={getDescription()}>
      {!hasFilters && (
        <div className="flex flex-row gap-4">
          <LinkButton to="../clients/add" variant="primary" startIcon="Add" size="md">
            Add Client
          </LinkButton>
        </div>
      )}
    </EmptyState>
  );
};
